import { message } from 'antd';

import { getCloudFlareUploadUrl, getSasToken, getTencentUploadTokenPost } from '@/service/upload';

import reportOther, { EReportOtherKey } from './report/reportOther';

const judgeFileType = (file: File) => {
  if (file.type) {
    return file.type;
  }

  // 对md做特殊判断，后续拓展可改为[]
  const markdownPattern = /\.md$/;

  if (markdownPattern.test(file.name)) {
    return 'text/markdown';
  }

  return '';
};

export default function handleUpload(
  file: File,
  path: string,
  filePrefix?: string,
  signal?: AbortSignal
): Promise<string> {
  return handleCloudFlareUpload(file, path, filePrefix, signal);
}

export function handleAzureUpload(file: File, path: string, filePrefix?: string): Promise<string> {
  const prefix = filePrefix ?? Date.now();
  const key = 'front-img/' + path + '/' + prefix + '/' + file.name.replace(/\s/g, '_');

  return getSasToken(key)
    .then((token) => {
      const blobBaseUrl = 'https://mindversestorage.blob.core.windows.net';
      const containerName = 'mindos-resource';

      return file.arrayBuffer().then((arrayBuffer) => {
        return fetch(`${blobBaseUrl}/${containerName}/${key}?${token}`, {
          method: 'PUT',
          headers: {
            Accept: 'application/xml',
            referer: 'https://app.me.bot/',
            'content-type': 'application/octet-stream',
            'x-ms-blob-type': 'BlockBlob',
            'x-ms-version': '2023-11-03',
            'x-ms-blob-content-type': judgeFileType(file)
          },
          body: arrayBuffer
        }).then((res) => {
          if (res.status === 201) {
            return 'https://frontdoorcdn.mindverse.ai/mindos-resource/' + key;
          }

          throw res;
        });
      });
    })
    .catch((error: Error) => {
      message.error('Upload Fail');
      console.error('Upload Fail', error);

      throw error;
    });
}

export function handleTencentUpload(
  file: File,
  path: string,
  filePrefix?: string
): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const prefix = filePrefix ?? Date.now();
    const key = 'front-img/' + path + '/' + prefix + '/' + file.name.replace(/\s/g, '_');

    const startTime = Date.now();

    getTencentUploadTokenPost({ blobName: key, globalBucket: true })
      .then((url) => {
        return file.arrayBuffer().then((arrayBuffer) => {
          return fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': judgeFileType(file)
            },
            body: arrayBuffer
          }).then((_res) => {
            if (_res.status === 200) {
              reportOther(EReportOtherKey.cos_upload_success, {
                key1: Date.now() - startTime,
                key2: file.size,
                key3: file.type
              });
              resolve(
                url
                  .replace(/\?.*$/, '')
                  .replace(/#/g, '%23')
                  .replace(
                    'https://mindverseglobal-1309544882.cos.na-siliconvalley.myqcloud.com/',
                    'https://mindverseglobal.mindverse.com/'
                  )
                  .replace(
                    'mindverseglobal-1309544882.cos.accelerate.myqcloud.com',
                    'mindverseglobal.mindverse.com'
                  )
              );
            }
          });
        });
      })
      .catch((error: Error) => {
        message.error('Upload Fail');
        console.error('Upload Fail', error);
        reportOther(EReportOtherKey.cos_upload_fail, {
          key1: Date.now() - startTime,
          key2: file.size,
          key3: file.type,
          key4: error.message
        });
        reject(error);
      });
  });
}

export function handleCloudFlareUpload(
  file: File,
  path: string,
  filePrefix?: string,
  signal?: AbortSignal
): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const prefix = filePrefix ?? Date.now();
    const key = 'front-img/' + path + '/' + prefix + '/' + file.name.replace(/\s/g, '_');

    const startTime = Date.now();

    getCloudFlareUploadUrl({ blobName: key })
      .then((data) => {
        return file.arrayBuffer().then((arrayBuffer) => {
          return fetch(data.url, {
            signal,
            method: 'PUT',
            headers: {
              'Content-Type': judgeFileType(file)
            },
            body: arrayBuffer
          }).then((_res) => {
            if (_res.status === 200) {
              reportOther(EReportOtherKey.cos_upload_success, {
                key1: Date.now() - startTime,
                key2: file.size,
                key3: file.type
              });
              resolve(
                data.url
                  .replace(/\?.*$/, '')
                  .replace(
                    'https://26b56aa82f374917a5304c161372c6b0.r2.cloudflarestorage.com/mindverseglobal/',
                    'https://object.me.bot/'
                  )
                  .replace(
                    'https://mindverseglobal-cos-1309544882.cos.ap-shanghai.myqcloud.com/',
                    'https://mindverseglobal-cos-cdn.mindverse.com/'
                  )
                  .replace(/#/g, '%23')
              );
            }
          });
        });
      })
      .catch((error: Error) => {
        message.error('Upload Fail');
        console.error('Upload Fail', error);
        reportOther(EReportOtherKey.cos_upload_fail, {
          key1: Date.now() - startTime,
          key2: file.size,
          key3: file.type,
          key4: error.message
        });
        reject(error);
      });
  });
}
